import { render, staticRenderFns } from "./Aasinet.vue?vue&type=template&id=0e9525b6&"
import script from "./Aasinet.vue?vue&type=script&lang=js&"
export * from "./Aasinet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports